import { useEffect, useState } from "react";
import { get, post } from "../../../redux/ApiHelper";
import { Column } from "../../../interfaces/table.interface";
import TableComponent from "../../../components/table/TableComponent";
import { formatDateTime } from "../../../utils/date&time.util";
import { IconButton, Tooltip } from "@mui/material";
import { FaCopy } from "react-icons/fa";
import { errorToast, successToast } from "../../../utils/toast.util";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { ContactAccessPaymentInterface } from "../../../interfaces/contact-access.interface";

const ContactAccessPayment = () => {
  const [paymentsList, setPaymentsList] = useState<
    ContactAccessPaymentInterface[]
  >([]);
  const [filteredPaymentsList, setFilteredPaymentsList] = useState<
    ContactAccessPaymentInterface[]
  >([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [verifyingMap, setVerifyingMap] = useState<Record<string, boolean>>({});
  const { signedAdmin } = useSelector((state: RootState) => state.admin);

  useEffect(() => {
    const queryParams = new URLSearchParams();
    queryParams.set("type", String(signedAdmin.type));
    queryParams.set("adminId", String(signedAdmin.id));
    get(`/admin/contact-access/payment-all?${queryParams.toString()}`).then((res) => {
      setPaymentsList(res);
      setFilteredPaymentsList(res);
    });
  }, []);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    const lowerQuery = query.toLowerCase();

    const filteredList = paymentsList?.filter((payment) => {
      const createdByName = payment.createdBy?.name?.toLowerCase() || "";
      const role = payment.role?.toLowerCase() || "";
      const transactionId = payment.transactionId?.toLowerCase() || "";
      const externalTransactionId =
        payment.externalTransactionId?.toLowerCase() || "";
      const paymentDate = formatDateTime(payment?.createdAt);

      return (
        payment._id.includes(lowerQuery) ||
        payment.amount.toString().includes(lowerQuery) ||
        payment.currency.toLowerCase().includes(lowerQuery) ||
        role.includes(lowerQuery) ||
        createdByName.includes(lowerQuery) ||
        transactionId.includes(lowerQuery) ||
        paymentDate.toLowerCase().includes(lowerQuery) ||
        externalTransactionId.includes(lowerQuery)
      );
    });

    setFilteredPaymentsList(filteredList);
  };

  const columns: Column[] = [
    { select: "_id", header: "Payment ID", align: "left" },
    { select: "role", header: "Role" },
    {
      header: "Created By",
      render: (_value: any, row: ContactAccessPaymentInterface) =>
        row?.createdBy?.name || "N/A",
    },
    {
      header: "amount",
      render: (_value: any, row: ContactAccessPaymentInterface) => {
       
        return <p>{row.amount}</p>
      },
    },
    { select: "currency", header: "Currency" },
    {
      header: "Status",
      render: (_value: any, row: ContactAccessPaymentInterface) => {
        const isCompleted = row?.status === "Completed";

        return (
          <div className="flex items-center">
            <span
              className={`status-badge ${
                isCompleted
                  ? "bg-green-500"
                  : row?.status === "Pending"
                  ? "bg-yellow-500"
                  : "bg-red-500"
              } text-white px-2 py-1 rounded`}
            >
              {row?.status}
            </span>
          </div>
        );
      },
    },
    {
      header: "Transaction ID",
      render: (_value: any, row: ContactAccessPaymentInterface) =>
        row?.transactionId || "N/A",
    },
    {
      header: "External Transaction ID",
      render: (_value: any, row: ContactAccessPaymentInterface) => {
        const transactionId = row?.externalTransactionId || "N/A";

        if (transactionId === "N/A") {
          return transactionId;
        }

        const handleCopy = () => {
          navigator.clipboard.writeText(transactionId);
          successToast("Transaction ID copied to clipboard!");
        };

        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ marginRight: 8 }}>
              {transactionId.slice(0, 10)}...
            </span>
            <Tooltip title="Copy Transaction ID">
              <IconButton
                onClick={handleCopy}
                size="small"
                aria-label="Copy Transaction ID"
              >
                <FaCopy />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
    {
      header: "Date & Time",
      render: (_value: any, row: ContactAccessPaymentInterface) =>
       <p className="whitespace-nowrap">{formatDateTime(row?.createdAt)}</p> ,
    },
  ];

  return (
    <div className="paymentsPage table-container">
      <div className="title">Contact Access Payments</div>
      <div className="search-container mb-4">
        <input
          type="text"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-700"
          placeholder="Search payments"
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>

      <TableComponent
        columns={columns.filter((item) => {
          if (
            signedAdmin.type === "franchise" &&
            (item.header === "Action" || item.header === "amount breakup")
          ) {
            return false;
          } else {
            return true;
          }
        })}
        data={filteredPaymentsList}
      />
    </div>
  );
};

export default ContactAccessPayment;
